import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Add the plugins to dayjs
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Converts UTC date string to local date
 * @param dateString - The UTC date string from the server
 * @returns A Date object in local timezone
 */
export function utcToLocal(dateString: string | Date | null | undefined): Date {
  if (!dateString) return new Date();

  return dayjs.utc(dateString).local().toDate();
}

/**
 * Formats a date to a readable string in local timezone
 * @param dateString - The UTC date string from the server
 * @param format - Optional format string (dayjs format)
 * @returns Formatted date string in local timezone
 */
export function formatLocalDate(
  dateString: string | Date | null | undefined,
  format = 'YYYY-MM-DD HH:mm'
): string {
  if (!dateString) return '';

  return dayjs.utc(dateString).local().format(format);
}
